/**
 * TODO: [BasicNumberInput]
 * Update the component internal logic by using context.
 */

import React from 'react';
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

export type BasicNumberInputProps = {
  label?: string;
  error?: boolean;
  helperText?: string;
  onIncrease?: () => void;
  onDecrease?: () => void;
} & OutlinedInputProps;

export const BasicNumberInput = ({
  label = 'Input number',
  error = false,
  helperText = '',
  onIncrease = () => {},
  onDecrease = () => {},
  ...rest
}: BasicNumberInputProps) => {
  return (
    <FormControl fullWidth variant="outlined" error={error}>
      <InputLabel>{label}</InputLabel>

      <OutlinedInput
        type="number"
        startAdornment={
          <InputAdornment position="start">
            <IconButton onClick={onDecrease} edge="start">
              <Remove />
            </IconButton>
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={onIncrease} edge="end">
              <Add />
            </IconButton>
          </InputAdornment>
        }
        label={label}
        inputProps={{ sx: { textAlign: 'center' } }}
        {...rest}
      />

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
